(() => {
  const topic = document.getElementById('CoinyContactTopic');
  if (!topic) return;
  const business = document.querySelector('.cm-v12-business-fields');
  const choose = value => {
    if (![...topic.options].some(option => option.value === value)) return;
    topic.value = value;
    if (business) business.open = ['Wholesale', 'Corporate gifting'].includes(value);
  };
  document.querySelectorAll('[data-cm-enquiry]').forEach(link => link.addEventListener('click', () => choose(link.dataset.cmEnquiry)));
  topic.addEventListener('change', () => choose(topic.value));
  const fromHash = () => {
    const value = { '#wholesale': 'Wholesale', '#corporate-gifting': 'Corporate gifting', '#media-enquiry': 'Media enquiry' }[location.hash];
    if (value) choose(value);
  };
  fromHash();
  addEventListener('hashchange', fromHash);
})();
